// extracted by mini-css-extract-plugin
export default {"header":"styles_header__iCKDe","header__search":"styles_header__search__F2VC3"};